module.exports = __webpack_public_path__ + "static/product_1_month-6f450156e44bc36cb15c24767dbebc26.png";